import { Injectable } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class SkillNodeService {
  constructor(private http: HttpClient) {}

  getFilesystem() {
    return {
      data: [
        {
          data: {
            name: 'Expertise',
            experience: '',
          },
          children: [
            {
              data: {
                name: 'Node.js',
                experience: '8 yrs.',
              },
            },
            {
              data: {
                name: 'FrontEnd',
                experience: '8 yrs.',
                type: 'Folder',
              },
            },
            {
              data: {
                name: 'Java',
                experience: '5.5yrs.',
              },
            },
            {
              data: {
                name: 'MongoDB',
                experience: '2 yrs.',
              },
            },
          ],
        },
        {
          data: {
            name: 'Node.js',
            experience: '8 yrs',
          },
          children: [
            {
              data: {
                name: 'Hapi.js',
                experience: '2 yrs.',
              },
            },
            {
              data: {
                name: 'express.js',
                experience: '6 yrs.',
              },
            },
            {
              data: {
                name: 'GraphQL',
                experience: '1+ yrs.',
              },
            },
            {
              data: {
                name: 'Seneca',
                experience: '2 yrs.',
              },
            },
            {
              data: {
                name: 'Unit Testing and coverage (Mocha , Chai , Istanbul )',
                experience: '6+ yrs.',
              },
            },
            {
              data: {
                name: 'Mongoose',
                experience: '2 yrs.',
              },
            },
          ],
        },
        {
          data: {
            name: 'FrontEnd',
            experience: '8 yrs',
          },
          children: [
             {
              data: {
                name: 'React.js',
                experience: '5.5 yrs.',
              },
            },
            {
              data: {
                name: 'Angular',
                experience: '2.5 yrs.',
              },
            },
            {
              data: {
                name: 'Typescript',
                experience: '4.5 yrs.',
              },
            },
            {
              data: {
                name: 'PrimeNg , Angular Material',
                experience: '2+ yrs',
              },
            },
            {
              data: {
                name: 'SASS',
                experience: '4 yrs.',
              },
            },
            {
              data: {
                name: 'Unit testing (Jasmine , Protractor)',
                experience: '5+ yrs.',
              },
            },
           
          ],
        },
        {
          data: {
            name: 'Database',
            experience: '....',
          },
          children: [
            {
              data: {
                name: 'MongoDB',
                experience: '2+ yrs',
              },
            },
            {
              data: {
                name: 'Redis',
                experience: '2+ yrs',
              },
            },
            {
              data: {
                name: 'Postgresql',
                experience: '3 yrs',
              },
            },
          ],
        },
        {
          data: {
            name: 'Security',
            experience: '5 yrs.',
          },
          children: [
            {
              data: {
                name: 'Passport.js ',
                experience: '....',
              },
            },
            {
              data: {
                name: 'SAML',
                experience: '....',
              },
            },
            {
              data: {
                name: 'OAuth',
                experience: '....',
              },
            },
            {
              data: {
                name: 'JWT ',
                experience: '....',
              },
            },
            {
              data: {
                name: 'Google Captcha',
                experience: '...',
              },
            },
          ],
        },
        {
          data: {
            name: 'Cloud',
            experience: '3+ yrs.',
          },
          children: [
            {
              data: {
                name: 'Microsoft Azure ',
                experience: '3+ yrs',
              },
            },
          ],
        },
        {
          data: {
            name: 'Devops and monitoring',
            experience: '3+ yrs.',
          },
          children: [
            {
              data: {
                name: 'Docker',
                experience: '4+ yrs',
              },
            },
            {
              data: {
                name: 'ELK and Filebeat ',
                experience: '1+ yrs',
              },
            },
          ],
        },
        {
          data: {
            name: 'Tools',
            experience: '...',
          },
          children: [
            {
              data: {
                name: 'Open API(Swagger) ',
                experience: '...',
              },
            },
            {
              data: {
                name: 'WebPack',
                experience: '....',
              },
            },
            {
              data: {
                name: 'ESlint',
                experience: '...',
              },
            },
            {
              data: {
                name: 'Grunt / Gulp ',
                experience: '...',
              },
            },
          ],
        },

        {
          data: {
            name: 'SCM',
            experience: '...',
          },
          children: [
            {
              data: {
                name: 'Github , SVN ',
                experience: '5+ yrs',
              },
            },
          ],
        },
        {
          data: {
            name: 'IOT',
            experience: 'POC',
          },
          children: [
            {
              data: {
                name: 'Raspberry Pi',
                experience: 'POC',
              },
            },
            {
              data: {
                name: 'MQTT',
                experience: 'POC',
              },
            },
            {
              data: {
                name: 'Node-RED',
                experience: 'POC',
              },
            },
          ],
        },
      ],
    };
  }
}
